import { DrawColor } from "$src/CGS/domain/dto/color/DrawColor";
import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { LengthValueMillimeter } from "$src/CGS/domain/dto/core/Length/LengthValueMillimeter";
import { ApplianceApertureIdentifier } from "$src/CGS/domain/dto/core/bones/ApplianceApertureIdentifier";
import { ICabinetShapeGeneratorParameters } from "./ICabinetShapeGeneratorParameters";

export class CabinetShapeGeneratorParameters implements ICabinetShapeGeneratorParameters {
    private fixedApplianceHeights: Map<ApplianceApertureIdentifier, LengthValue> = new Map();
    private frontDoorColor!: DrawColor;

    setInsideApplianceHeight(applianceApertureIdentifier: ApplianceApertureIdentifier, height: LengthValue): void {
        this.fixedApplianceHeights.set(applianceApertureIdentifier, height);
    }

    getInsideApplianceHeight(applianceApertureIdentifier: ApplianceApertureIdentifier): LengthValue {
        return this.fixedApplianceHeights.get(applianceApertureIdentifier) ?? new LengthValueMillimeter(0);
    }

    getFrontDoorColor(): DrawColor {
        return this.frontDoorColor;
    }

    setFrontDoorColor(drawColor: DrawColor): void {
        this.frontDoorColor = drawColor;
    }
}